import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  navbarRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 54,
    boxShadow: theme.shadows[0],
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: "white"
  },
  logoClass: {
    width: "80%"
  },

  leftContainer: {
    justifyContent: "flex-start",
    alignItems: "center",
    padding: theme.spacing(0, 3),
    fontSize: 20,
    "& button": {
      color: theme.palette.jamii.darkAccent
    }
  },

  centerContainer: {
    justifyContent: "center",
    alignItems: "center",
    "& a": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  },

  rightContainer: {
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(0, 3),
    fontSize: 20,
    "& button": {
      color: theme.palette.jamii.darkAccent
    }
  }
}));
